module.exports = __webpack_public_path__ + "img/frame (145).4ba6226f.jpg";